import store from "@/store";

export default [
  {
    name: "google",
    path: "/oauth/google",
    beforeEnter: async (to, from, next) => {
      await store.dispatch("oauth/login", {
        provider: "google",
        data: { ...to.query, host: `${location.protocol}//${location.host}` }
      });

      setTimeout(() => {
        next("/");
      }, 1000);
    }
  },
  {
    name: "vkontakte",
    path: "/oauth/vkontakte",
    beforeEnter: async (to, from, next) => {
      await store.dispatch("oauth/login", {
        provider: "vkontakte",
        data: { ...to.query, host: `${location.protocol}//${location.host}` }
      });

      setTimeout(() => {
        next("/");
      }, 1000);
    }
  },
  {
    name: "odnoklassniki",
    path: "/oauth/odnoklassniki",
    beforeEnter: async (to, from, next) => {
      await store.dispatch("oauth/login", {
        provider: "odnoklassniki",
        data: { ...to.query, host: `${location.protocol}//${location.host}` }
      });

      setTimeout(() => {
        next("/");
      }, 1000);
    }
  },
  {
    name: "facebook",
    path: "/oauth/facebook",
    beforeEnter: async (to, from, next) => {
      await store.dispatch("oauth/login", {
        provider: "facebook",
        data: { ...to.query, host: `${location.protocol}//${location.host}` }
      });

      setTimeout(() => {
        next("/");
      }, 1000);
    }
  }
];
